const COMMAND_STATS_PATH = "/api/command";

export function trackCommand(input: string, command: string): void {
    const trimmedInput = input.trim();
    const trimmedCommand = command.trim();
    if (!trimmedCommand) return;

    const cmd = trimmedCommand.split(/\s+/)[0]?.toLowerCase() ?? "";
    if (!cmd) return;

    const body = JSON.stringify({
        input: trimmedInput || trimmedCommand,
        command: trimmedCommand,
        cmd,
    });

    try {
        void fetch(COMMAND_STATS_PATH, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body,
            keepalive: true,
        });
    } catch {
        // Stats are best-effort and must not affect the terminal.
    }
}
